app
    .controller('OrderSendCompleteCtrl', function ($http) {

        this.cancel = () => {
            this.dismiss();
        };

        this.$onInit = () => {
        };
    })
    .component('orderSendComplete', {
        template: `
        <div style="width: 100%; min-width: 32vw;">
            <div class="header p-1 text-center font-go-bold" style="border-bottom: 1px solid #1D1D1B">
                SEND A OFFER
            </div>
            <style>
                .isSelected{
                   background-color: #1da1f2;
                }
            </style>
            <div class="body">
                <div style="height: 20vh; display: flex; justify-content: center; align-items: center;">
                    <div>
                        <p class="font-go-bold" style="font-size: 18px;">{{ 'modal.sendOffer.success' | translate }}</p>
                    </div>
                </div>
            </div>
            <div class="footer text-center mb-2">
                <button class="btn btn-slim btn-green font-go-bold btn-200" ng-click="$ctrl.cancel()">
                    {{ 'modal.orderComplete.close' | translate }}
                </button>
            </div>
        </div>
        `,
        bindings: {
            resolve: '<',
            close: '&',
            dismiss: '&'
        },
        controller: 'OrderSendCompleteCtrl'
    });
